import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/homePage/homePage.vue')
  },
  {
    path: '/espaceagent',
    name: 'espace-agent',
    component: () => import('../views/espaceAgent/espaceAgent.vue')
  },
  {
    path: '/devis/auto',
    name: 'devis-auto',
    component: () => import('../views/devis/devisAuto.vue')
  },
  {
    path: '/devis/habitation',
    name: 'devis-habitation',
    component: () => import('../views/devis/devisHabitation.vue')
  },
  {
    path: '/devis/voyage',
    name: 'devis-voyage',
    component: () => import('../views/devis/devisVoyage.vue')
  },
  {
    path: '/devis/offre',
    name: 'liste_offre_devis',
    component: () => import('../views/devis/listeOffreDevis.vue')
  },
  {
    path: '/edit/devis/auto',
    name: 'edit_devis',
    component: () => import('../views/devis/editDevisAuto.vue')
  },
  // Simulatation Router
   {
    path: '/simulate/devis/auto',
    name: 'simulate-devis-auto',
    component: () => import('../views/simulate/simulateAuto.vue')
  },
  {
    path: '/simulate/devis/voyage',
    name: 'simulate-devis-voyage',
    component: () => import('../views/simulate/simulateVoyage.vue')
  },
   {
    path: '/simulate/devis/offre',
    name: 'simulate-liste_offre_devis',
    component: () => import('../views/simulate/listeOffreSimulate.vue')
  },
  {
    path: '/simulate/to/devis/auto',
    name: 'simule-to-devis-auto',
    component: () => import('../views/simulate/simuleToDevisAuto.vue'),
    props: true
  },
   {
    path: '/simulate/to/devis/voyage',
    name: 'simule-to-devis-voyage',
    component: () => import('../views/simulate/simuleToDevisVoyage.vue'),
    props: true
  },
  {
    path: '/devis/payment',
    name: 'edit_devis',
    component: () => import('../views/payment/payment.vue')
  },
  {
    path: '/payment/success',
    name: 'edit_devis',
    component: () => import('../views/payment/successPayment.vue')
  },
  {
    path: '/payment/wave',
    name: 'wavepayment',
    component: () => import('../views/payment/waveResponse.vue')
  },
  {
    path: '/apropos',
    name: 'wavepayment',
    component: () => import('../views/apropos/apropos.vue')
  },
  {
    path: '/soumission-contrat',
    name: 'soumission-contrat',
    component: () => import('../components/contrat_upload.vue')
  },
  {
    path: '/set-password/*',
    name: 'set_password',
    component: () => import('../components/set_password.vue')
  },
  {
    path: '/password/recovery/:token',
    name: 'recoveryPassword',
    component: () => import('../components/recovery_password.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile/profilePage.vue')
  },
  {
    path: '/verify/agent/:id',
    name: 'verify-agent',
    component: () => import('../views/verify/verifyAgent.vue')
  },
  {
    path: '/auth/magiclink',
    name: 'agent_magiclink',
    component: () => import('../components/AgentLight/AgentLightOnboarding.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/agent-light/onboarding',
    name: 'agent_light_onboarding',
    component: () => import('../components/AgentLight/AgentLightOnboarding.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/flyer',
    name: 'flyer',
    component: () => import('../views/flyer/flyer.vue'),
    meta: { requiresAuth: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
